import { Modal } from "~/components/AccountActions/modal.web";
import { CopySaveForm, CopySaveFormProps } from "~/components/CopySave/Form";

export function CopySaveDialog(
  props: Pick<CopySaveFormProps, "saveId" | "srcSpaceId"> & {
    onDismiss: () => void;
  },
) {
  return (
    <Modal onDismiss={props.onDismiss} header="Copy Save">
      <CopySaveForm {...props} onSuccess={props.onDismiss} />
    </Modal>
  );
}
